import AppShell from './AppShell'
import { ErrorBoundary } from './ErrorBoundary'
import { PWAUpdate } from '../shared/PWAUpdate'

export default function App() {
  return (
    <>
      <ErrorBoundary>
        <AppShell />
      </ErrorBoundary>
      <PWAUpdate />
    </>
  )
}
